import { render } from "./Prescription.vue?vue&type=template&id=e6460824"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__